/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RoleRead } from "../../models/role-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetRole$Params {
  organisation_id: string;
  role_id: string;
}

export function getRole(
  http: HttpClient,
  rootUrl: string,
  params: GetRole$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RoleRead>> {
  const rb = new RequestBuilder(rootUrl, getRole.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("role_id", params.role_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleRead>;
    }),
  );
}

getRole.PATH = "/surfdomeinen/organisations/{organisation_id}/auth/roles/{role_id}";
